import "./Modal.scss";
import "./AddAmenityModal.scss";
import { useEffect } from "react";

function AddAmenityModal({
  amenityModalOpen,
  newAmenityName,
  boatAmenityModal,
  selectedAmenityIds,
  allGlobalAmenities,
  setNewAmenityName,
  setBoatAmenityModal,
  setSelectedAmenityIds,
  onCloseAmenityModal,
  onCloseBoatAmenityModal,
  onCreateAmenity,
  onToggleBoatAmenity,
  onSaveBoatAmenities,
}) {
  useEffect(() => {
    const isAnyModalOpen = amenityModalOpen || boatAmenityModal;
    if (isAnyModalOpen) {
      document.body.style.overflow = "hidden";
      return () => {
        document.body.style.overflow = "";
      };
    }
  }, [amenityModalOpen, boatAmenityModal]);

  return (
    <>
      {/* ── Add Amenity Modal ── */}
      {amenityModalOpen && (
        <div
          className="popup-overlay-admin"
          onClick={(e) =>
            e.target.classList.contains("popup-overlay-admin") &&
            onCloseAmenityModal()
          }
        >
          <div className="popup-content">
            <button className="close-button" onClick={onCloseAmenityModal}>
              &times;
            </button>
            <h1>Add New Amenity</h1>
            <div className="edit-info">
              <label>
                Amenity Name
                <input
                  value={newAmenityName}
                  onChange={(e) => setNewAmenityName(e.target.value)}
                  placeholder="e.g. Toilet, Snorkeling Gear, Life Jackets"
                  onKeyDown={(e) => e.key === "Enter" && onCreateAmenity()}
                />
              </label>
              <small className="amenity-hint">
                Amenities are shown to customers on the booking form so they know what's available on the boat.
              </small>
            </div>
            <div className="modal-footer">
              <button className="cancel-btn" onClick={onCloseAmenityModal}>
                Cancel
              </button>
              <button className="save-btn" onClick={onCreateAmenity}>
                Add Amenity
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ── Boat Amenity Assignment Modal ── */}
      {boatAmenityModal && (
        <div
          className="popup-overlay-admin"
          onClick={(e) =>
            e.target.classList.contains("popup-overlay-admin") &&
            onCloseBoatAmenityModal()
          }
        >
          <div className="popup-content">
            <button className="close-button" onClick={onCloseBoatAmenityModal}>
              &times;
            </button>
            <h1>Amenities for {boatAmenityModal.name}</h1>
            {allGlobalAmenities && allGlobalAmenities.length > 0 ? (
              <div className="checkbox-list">
                {allGlobalAmenities.map((amenity) => (
                  <label key={amenity._id}>
                    <input
                      type="checkbox"
                      checked={selectedAmenityIds.includes(amenity._id)}
                      onChange={() => onToggleBoatAmenity(amenity._id)}
                    />
                    {amenity.name}
                  </label>
                ))}
              </div>
            ) : (
              <p className="no-amenities-msg">No amenities created yet. Add some first.</p>
            )}
            <div className="modal-footer">
              <button className="cancel-btn" onClick={onCloseBoatAmenityModal}>
                Cancel
              </button>
              <button className="save-btn" onClick={onSaveBoatAmenities}>
                Save Amenities
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default AddAmenityModal;
